import { render, staticRenderFns } from "./BaseQuestionLevel.vue?vue&type=template&id=cbf7c90a&"
import script from "./BaseQuestionLevel.vue?vue&type=script&lang=js&"
export * from "./BaseQuestionLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports